export function validateEmail(email){
    if(!checkEmail(email)) {
        return {
            result: false,
            message: "Please enter a valid email address!"
        };
    }
    return {
        result: true,
        message: "valid"
    };
}


export function validatePassword(pwd1){

    if(!checkPassword(pwd1)) {
        return {
            result: false,
            message: " must contain at least 8 characters, including UPPER/lowercase and numbers."
        };
    }

    return {
        result: true,
        message: "valid"
    };
}

export function validateLowercaseNoSpaces(val){

    if(!checkLowercaseNoSpaces(val)) {
        return {
            result: false,
            message: " must not contain uppercase characters or spaces."
        };
    }

    return {
        result: true,
        message: "valid"
    };
}

export function checkPasswordsMatch(pwd1, pwd2){
    if(pwd1.length === 0 || pwd2.length === 0  || pwd1 !== pwd2) {
        return {
            result: false,
            message: "Please check that you've entered and confirmed your password!"
        };
    }
    return {
        result: true,
        message: "valid"
    };
}

export function validateLength(string){
    if(string.length === 0) {
        return {
            result: false,
            message: "must not be empty."
        };
    }
    return {
        result: true,
        message: "valid"
    };
}

export function validatePasswordCritea(pwd){
    let exceedMinLength = pwd.length >= 8;
    let containsLowercase= checkContainsLower(pwd);
    let containsUppercase = checkContainsUpper(pwd);
    let containsNumeric = checkContainsNumeric(pwd);
    let isValid = false;

    if(exceedMinLength && containsLowercase && containsUppercase && containsNumeric){
        isValid = true;
    }
    return {
        isValid: isValid,
        exceedMinLength: exceedMinLength,
        containsLowercase: containsLowercase,
        containsUppercase:  containsUppercase,
        containsNumeric:  containsNumeric
    };
}


//private
function checkEmail(srt){
    let re = /^(([^<>()\\[\]\\.,;:\s@"]+(\.[^<>()\\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    let res = /^(([^<>()\\[\]\\.,;:\s@"]+(\.[^<>()\\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    let bitch = /^(.+):\/\/([^:\\/]*):?(\d+)?(\/.*)?$/;

    return re.test(srt);
}

function checkPassword(str)
{
    let re = /(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}/;
    return re.test(str);
}

function checkContainsLower(str)
{
    let re = /(?=.*[a-z])/;
    return re.test(str);
}

function checkContainsUpper(str)
{
    let re = /(?=.*[A-Z])/;
    return re.test(str);
}

function checkContainsNumeric(str)
{
    let re = /(?=.*\d)/;
    return re.test(str);
}

function checkLowercaseNoSpaces(str)
{
    let re = /^[a-z0-9]+(\s+[a-z0-9]+)?$/;
    return re.test(str);
}


/** WEBPACK FOOTER **
 ** ./src/helpers/formValidationHelper.js
 **/